// SmartFeedSeeAllDestination.js
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import SmartFeedPagination from "~/dynamic-components/options/smart-feed-pagination";
import { titleToKebabCase } from "@bloglovin/vue-framework";
import { useConfigurationPanelStore } from "~/stores/configuration-panel-store";
import useFanPublicationStore from "%/stores/fan-publication-store";
import { useGeneralStore } from "%/stores/general-store";

export default class SmartFeedSeeAllDestination extends BaseOption {
  static label = "See All Destination Page";
  static userInterfaceComponent = {
    component: inspectorTools.AUTOCOMPLETE,
    props: {
      isAsync: true,
      showAllResultsOnClick: true,
      sourceUrl: () => {
        return useGeneralStore().apiV1 + `/publication/${useFanPublicationStore().publicationId}/pages/autocomplete`;
      },
      itemValueKey: "value",
      itemLabelKey: "label",
      canCreateNewItem: true,
      customItemLabel: "Create new page",
      placeholder: "Search pages...",
      runInitialSearch: true,
      includeValueType: "string",
      onCreateItem: (data, context) => {
        const pageName = data.query;
        const pageSlug = titleToKebabCase(pageName);

        useConfigurationPanelStore().createDynamicPage({
          name: pageName,
          slug: pageSlug,
          template: 0,
        }, () => {
          context.setValue({
            value: pageSlug,
            label: pageName,
          });
        });
      },
    },
  };
  static defaultValue = "";
  static canShow(paginationType) {
    return paginationType.id === SmartFeedPagination.optionValues.linkToViewAllPage.id;
  }
}
